import { createElement } from 'react';
import './index.scss';
import arror from '../../assets/icon/position/arror.png';
const NavigationLeft = function navigationLeft({ currentLocation, clickHandle, ...otherProps }) {
    return (createElement("div", null,
        createElement("div", { className: "location", ...otherProps, onClick: () => clickHandle() },
            createElement("div", { className: "location-address" }, currentLocation.address),
            createElement("div", { className: "location-icon" },
                createElement("img", { src: arror, width: "10", height: "5", alt: "icon" })))));
};
export default NavigationLeft;
